import {
  BeeOrchestratorToolCallStrategy,
  BeeOrchestratorParamsSchema,
} from './BeeOrchestratorToolStrategy';
import { FlamingoAgenticImagineToolCallStrategy } from './FlamingoGraphToolStrategy';
import { z } from 'zod';
import { ToolCallStrategy, BaseParamsSchema, BaseParams } from './BaseToolStrategy';

export interface StrategyMap {
  [key: string]: {
    StrategyClass: new (params: any) => ToolCallStrategy;
    paramSchema: z.ZodObject<BaseParams>;
  };
}

export const strategyRegistry: StrategyMap = {
  // TODO: Deprecated, remove BeeAgentCompletion after migration to BeeOrchestrator
  BeeAgentCompletion: {
    StrategyClass: BeeOrchestratorToolCallStrategy,
    paramSchema: BeeOrchestratorParamsSchema,
  },
  BeeOrchestrator: {
    StrategyClass: BeeOrchestratorToolCallStrategy,
    paramSchema: BeeOrchestratorParamsSchema,
  },
  FlamingoAgenticImagine: {
    StrategyClass: FlamingoAgenticImagineToolCallStrategy,
    paramSchema: BaseParamsSchema,
  },
};

export const ToolStrategyKeys = Object.keys(strategyRegistry);

export function initializeStrategy(key: string, parameters: Record<string, any>) {
  const strategy = strategyRegistry[key];
  if (!strategy) {
    throw new Error(`Strategy ${key} not found`);
  }
  const params = strategy.paramSchema.parse(parameters);
  return new strategy.StrategyClass(params);
}
